let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3I5VS")).then(() => parcelRequire('f3r1O'));